export function GetFromSessionStorage(storageKey: string) {
  if (window.sessionStorage) {
    return window.sessionStorage.getItem(storageKey);
  }
  return null;
}

export function SetInSessionStorage(storageKey: string, value: string) {
  if (window.sessionStorage) {
    window.sessionStorage.setItem(storageKey, value);
  }
}

export function GetFromLocalStorage(storageKey: string) {
  if (window.localStorage) {
    return window.localStorage.getItem(storageKey);
  }
  return null;
}

export function SetInLocalStorage(storageKey: string, value: string) {
  if (window.localStorage) {
    window.localStorage.setItem(storageKey, value);
  }
}

export function clearSessionStorage(storageKey: string) {
  if (window.sessionStorage) {
    window.sessionStorage.removeItem(storageKey);
  }
}
